export default {
  checkbox: {
    type: Boolean
  },

  disabled: {
    type: Boolean
  },

  trueValue: {
    type: String
  },

  value: {
    type: [ Array, Boolean ]
  },

  clickable: {
    type: Boolean
  },

  readOnly: {
    type: Boolean
  },

  checkIcon: {
    type: String,
    default: 'check'
  }
}
